import keyBy from 'lodash/keyBy';
import { TableNoLeftRightBorders } from 'components/base/layout-components';
import { useSelector } from 'react-redux';
import Table from 'components/base/Table';
import TableSkeleton from 'components/base/Skeletons';
import {
  tableColumns,
  skeletonColumns,
  formattedTeamMembersForTable
} from './services/contributor.service';
import Header from './components/Header';
import useContributor from './hooks/useContributor';
import { teamsWithExtraSyncedDataSelector } from 'state/selectors/teams';
import { isTeamLicenseSelector } from 'state/selectors/license';
import { contributorsWithTeamIdsSelector } from 'state/selectors/contributors';

const Contributor = ({
  currentTeams,
  contributors,
  license,
  getTeams,
  toggleModal,
  toggleSnackBar
}) => {
  const {
    filteredTeamMembers,
    teamMembers,
    setSearchTerm,
    licenseNextPaymentDate,
    isNotInTeamSelected,
    setIsNotInTeamSelected,
    isInTeamSelected,
    setIsInTeamSelected
  } = useContributor({
    currentTeams,
    contributors,
    license
  });
  const isTeamLicense = useSelector(isTeamLicenseSelector);
  const teamsWithExtraData = useSelector(teamsWithExtraSyncedDataSelector);
  const contributorsWithTeamIds = useSelector(contributorsWithTeamIdsSelector);
  const totalContributors = contributorsWithTeamIds?.length;
  const totalActiveContributors = contributorsWithTeamIds.filter(
    contributor => contributor?.teamIds.length
  ).length;

  if (!filteredTeamMembers) {
    return null;
  }

  const contributorsIds = keyBy(contributors, 'id');

  const formattedTableData = formattedTeamMembersForTable(
    filteredTeamMembers,
    teamMembers,
    getTeams,
    licenseNextPaymentDate,
    toggleModal,
    toggleSnackBar,
    contributorsIds,
    isTeamLicense
  );

  return (
    <div className='pt-3'>
      {!(filteredTeamMembers === null) ? (
        <>
          <Header
            setSearchTerm={setSearchTerm}
            teamMembers={teamMembers}
            teamsWithExtraData={teamsWithExtraData}
            totalContributors={totalContributors}
            totalActiveContributors={totalActiveContributors}
            isTeamLicense={isTeamLicense}
            isNotInTeamSelected={isNotInTeamSelected}
            setIsNotInTeamSelected={setIsNotInTeamSelected}
            isInTeamSelected={isInTeamSelected}
            setIsInTeamSelected={setIsInTeamSelected}
          ></Header>
          <TableNoLeftRightBorders>
            {/* @ts-expect-error */}
            <Table
              columns={tableColumns}
              data={formattedTableData}
              withPagination
              clientSidePagination
            />
          </TableNoLeftRightBorders>
        </>
      ) : (
        <TableSkeleton
          columns={tableColumns}
          skeletonColumns={skeletonColumns}
        />
      )}
    </div>
  );
};

export default Contributor;
